import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Avatar,
  Button,
  Col,
  Divider,
  Image,
  List,
  Modal,
  Row,
  Skeleton,
  Spin,
} from "antd";
import InfiniteScroll from "react-infinite-scroll-component";
import { ListItemLayout } from "antd/es/list";
import { useAppDispatch } from "app/hooks";
import { FilterImage, ImageJson } from "features/comment/types/gallery.type";
import ImageModel from "common/models/ImageModel";
import {
  useGetImageListPublicQuery,
  useGetReviewListPublicQuery,
} from "features/comment/service/comment.service";
import { isEntityError, isFetchError } from "common/utils/errorResultRTK";
import FileModel from "common/models/FileModel";
import SkeletonImageCustom from "./SkeletonImageCustom";
import ResultErrors from "templates/ResultErrors";
import VirtualList from "rc-virtual-list";
import ReviewDetail, { ReviewDetailList } from "../commentDetail/ReviewDetail";
import { DataType } from "../list/CommentList";
export interface DataTypeImage extends ImageJson {
  loading?: boolean;
}

interface DataTypes {
  gender: string;
  name: {
    title: string;
    first: string;
    last: string;
  };
  email: string;
  picture: {
    large: string;
    medium: string;
    thumbnail: string;
  };
  nat: string;
}

type Props = {
  dataSource: ReviewDetailList[];
  itemRender?: (item: any, index: number) => React.ReactNode;
  itemLayout?: ListItemLayout;
  styleWrapper?: React.CSSProperties;
  classWrapper?: string;
  labelLoadMore?: string;
  styleLabelLoadMore?: React.CSSProperties;
  heightOverFlow?: string | number | undefined;
  borderOverFlow?: boolean;
  hiddenScrollBar?: boolean;
  item_id?: string;
  item_type?: string;
};
const Data = [
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
  {
    company_id: 0,
    creator_id: 0,
    id: 0,
    directory_id: 0,
    object_type: 0,
    object_id: 0,
    md5_hash: "",
    file_path: "",
    width: 0,
    height: 0,
    randomcode: "",
    title: "",
    description: "",
    extension: "",
    size_in_byte: 0,
    origin: "",
    status: 0,
    is_directory: 0,
    ip_address: "",
    date_created: 0,
    date_modified: 0,
    url: "",
  },
];

const CommentGallery = ({
  dataSource,
  itemRender,
  itemLayout,
  styleWrapper,
  classWrapper,
  labelLoadMore = "Xem thêm",
  heightOverFlow = 500,
  borderOverFlow = false,
  hiddenScrollBar = false,
  styleLabelLoadMore = {
    textAlign: "left",
    marginTop: 12,
    height: 32,
    lineHeight: "32px",
  },
  item_id,
  item_type,
}: Props) => {
  const dispatch = useAppDispatch();
  ////
  const [loading, setLoading] = useState(false);
  // const [data, setData] = useState<DataTypes[]>([]);
  const [gallery, setGallery] = useState<DataTypeImage[]>([]);
  const [showReviewDetail, setShowReviewDetail] = useState(false);
  const [defaultSlideReview, setDefaultSlideReview] = useState(0);

  const [scrollableTarget, setScrollableTarget] =
    useState<HTMLDivElement | null>(null);

  // const [filters, setFilters] = useState<FilterImage>({
  //   ...ImageModel.getDefaultFilter(),
  //   item_id: item_id ? item_id : undefined,
  //   item_type: item_type ? item_type : undefined,
  // });
  //
  // const {
  //   data: imageList,
  //   isLoading,
  //   isError,
  //   isSuccess,
  //   error,
  // } = useGetImageListPublicQuery({ ...filters, limit: 100 }, { skip: false });
  // const {} = useGetReviewListPublicQuery();

  // const erorrFetch = useMemo(() => {
  //   if (isEntityError(error)) {
  //     return {
  //       status: error.status,
  //       errors: error.data.error,
  //     };
  //   } else if (isFetchError(error)) {
  //     return {
  //       status: error.status,
  //       errors: [error.error],
  //     };
  //   }
  // }, [error]);
  ////
  const handleLoadMore = () => {
    // if (loading) {
    //   return;
    // }
    // setLoading(true);
    // console.log("mass");
    // setTimeout(() => {
    //   setFilters((prev) => {
    //     return {
    //       ...prev,
    //       page: prev.page + 1,
    //     };
    //   });
    //   setLoading(false);
    // }, 2000);

    window.dispatchEvent(new Event("resize"));
  };

  // const hasMore: boolean = useMemo(() => {
  //   if (imageList) {
  //     if (gallery?.length < imageList?.total) {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   } else {
  //     return false;
  //   }
  // }, [imageList, gallery]);

  // const containerHeight = 200;
  // const onScroll = (e: React.UIEvent<HTMLElement, UIEvent>) => {
  //   if (
  //     e.currentTarget.scrollHeight - e.currentTarget.scrollTop ===
  //     containerHeight
  //   ) {
  //     handleLoadMore();
  //   }
  // };
  // const handleScroll = () => {
  //   if (
  //     scrollableTarget &&
  //     scrollableTarget.scrollTop + scrollableTarget.clientHeight >=
  //       scrollableTarget.scrollHeight * 0.9 &&
  //     hasMore &&
  //     !loading
  //   ) {
  //     handleLoadMore();
  //   }
  // };

  ///

  // useEffect(() => {
  //   if (imageList && imageList.items?.length > 0) {

  //     setGallery(imageList.items);
  //   }
  // }, [imageList]);

  return (
    <div
      id="scrollableDiv"
      className="galley_wrapper"
      style={{
        height: "auto",
        overflow: "auto",
      }}
      // className="webkit-scroll"
    >
      {/* {isError ? (
        <ResultErrors
          prefixError="comment:errors"
          error={erorrFetch?.errors}
        ></ResultErrors>
      ) : (
        <InfiniteScroll
          onScroll={handleLoadMore}
          dataLength={gallery.length}
          next={handleLoadMore}
          hasMore={false}
          onScroll={handleLoadMore}
          loader={
            <Row style={{}}>
              <Col span={8}>
                <Skeleton avatar active loading={loading}></Skeleton>
              </Col>
              <Col span={8}>
                <Skeleton avatar active loading={loading}></Skeleton>
              </Col>
              <Col span={8}>
                <Skeleton avatar active loading={loading}></Skeleton>
              </Col>
            </Row>
          }
          loader={<></>}
          endMessage={<></>}
          scrollableTarget={"scrollableDiv" || "antd_"}
          // scrollableTarget="modal-content"
          // onScroll={handleLoadMore}
        >
          <List
            loading={false}
            loadMore={
              <Button
                style={{
                  opacity: 0,
                  display: "none",
                }}
              >
                Xem thêm
              </Button>
            }
            grid={{
              gutter: 8,
              xs: 4,
              sm: 4,
              md: 4,
              lg: 7,
              xl: 7,
              xxl: 7,
              column: 4,
              }}

            size="small"
            dataSource={gallery}
            renderItem={(item: DataTypeImage, index: number) => (
              <List.Item>
                {item.loading ? (
                  // <div
                  //   style={{
                  //     width: "100%",
                  //     height: "100%",
                  //     display: "flex",
                  //     justifyContent: "center",
                  //     alignItems: "center",
                  //   }}
                  // >
                  //   <Skeleton.Image rootClassName="aa" active />
                  // </div>
                  // <SkeletonImageCustom></SkeletonImageCustom>
                  <Skeleton active title={true} round={false}></Skeleton>
                ) : itemRender ? (
                  itemRender(item, index)
                ) : (
                  <Image
                    loading="eager"
                    width={"100%"}
                    className="image_galley"
                    style={{ borderRadius: "8px", objectFit: "cover" }}
                    preview={{
                      mask: (
                        <div
                          style={{ zIndex: 1000000000000000000000000 }}
                        ></div>
                      ),
                      destroyOnClose: true,

                      // keyboard: false,
                      // modalRender(node) {
                      //   return (
                      //     <div>
                      //       <ReviewDetail
                      //         dataSource={gallery}
                      //         defaultIndexSlide={0}
                      //       ></ReviewDetail>
                      //     </div>
                      //   );
                      // },
                    }}

                    src={FileModel.getThumbnailFromUrl(
                      item.file_path,
                      // 1080,
                      1080,
                      756,
                      "crop"
                    )}
                  />
                )}
              </List.Item>
            )}
          />
          </InfiniteScroll>
        
      )} */}
      <div className="comment_galley_grid">
        {dataSource.length > 0 &&
          dataSource.map((item, index) => {
            return (
              <div className="image_wrapper">
                <Image
                  loading="eager"
                  width={"100%"}
                  className="image_galley"
                  style={{
                    borderRadius: "8px",
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                  preview={false}
                  onClick={() => {
                    setDefaultSlideReview(index);
                    setShowReviewDetail(true);
                  }}
                  // preview={{
                  //   mask: (
                  //     <div
                  //       style={{ zIndex: 1000000000000000000000000 }}
                  //     ></div>
                  //   ),
                  //   destroyOnClose: true,
                  //   // keyboard: false,
                  //   // modalRender(node) {
                  //   //   return (
                  //   //     <div>
                  //   //       <ReviewDetail
                  //   //         dataSource={gallery}
                  //   //         defaultIndexSlide={0}
                  //   //       ></ReviewDetail>
                  //   //     </div>
                  //   //   );
                  //   // },
                  // }}
                  src={
                    item.images.length > 0 &&
                    item.activeImage !== undefined &&
                    item.images[item.activeImage].file_path !== undefined
                      ? FileModel.getThumbnailFromUrl(
                          item.images[item.activeImage].file_path,
                          500,
                          500,
                          "crop"
                        )
                      : ""
                  }
                />
              </div>
            );
          })}
      </div>
      <Modal
        wrapClassName="review-detail-modal modal-review-wrapper"
        closable={true}
        open={showReviewDetail}
        cancelText={"Đóng"}
        className={`modal_reviewDetail`}
        onCancel={() => {
          setShowReviewDetail(false);
          setDefaultSlideReview(0);
          // setTimeout(() => {
          //   setDelayDetroy(false);
          // }, 500);
        }}
        centered
        okButtonProps={{ style: { display: "none" } }}
        cancelButtonProps={{ style: { display: "none" } }}
        width={"881px"}
        destroyOnClose={true}
        rootClassName="scrollableDiv_review "
        forceRender={false}
        getContainer={false}
        transitionName="custom-transition"
        footer={null}
        zIndex={1130}
      >
        {dataSource.length > 0 && (
          <ReviewDetail
            dataSource={dataSource}
            // dataReviewDetail={dataReviewDetail}
            visible={showReviewDetail}
            defaultIndexSlide={defaultSlideReview}
            // defaultIndexImg={defaultIndexImg}
            // defaultImageItem={}
          ></ReviewDetail>
        )}
      </Modal>
    </div>
  );
};

export default CommentGallery;
